import { LoadingComponent } from '@/components/ui/LoadingComponent'
import { Suspense, useMemo, useState } from 'react'
import { Outlet } from 'react-router'

export type WorkspacesOutletContext = {
  view: 'cards' | 'table'
  setView: (view: 'cards' | 'table') => void
}

export const WorkspacesRootLayout = () => {
  const [view, setView] = useState<'cards' | 'table'>('cards')
  const outletContext: WorkspacesOutletContext = useMemo(
    () => ({
      view,
      setView,
    }),
    [view]
  )
  return (
    <Suspense fallback={<LoadingComponent />}>
      <Outlet context={outletContext} />
    </Suspense>
  )
}
